import classnames from 'classnames2';
import React from 'react';

var Container = function Container(props) {
  return React.createElement("svg", {
    className: props.className,
    width: 66,
    height: 32,
    "aria-hidden": true,
    viewBox: "0 0 66 32"
  }, props.children);
};

var Track = function Track(props) {
  return React.createElement("rect", {
    width: "64",
    height: "28",
    rx: "14",
    x: "1",
    y: "2",
    className: props.className
  });
};

var Knob = function Knob(props) {
  return React.createElement("circle", {
    r: "16",
    cx: "17",
    cy: "16",
    className: props.className
  });
};

export var SwitchIndicatorSVG = function SwitchIndicatorSVG(props) {
  return React.createElement("div", {
    className: props.containerClassName
  }, React.createElement(Container, {
    className: props.svgContainerClassName
  }, React.createElement(Track, {
    className: props.trackClassName
  })), React.createElement(Container, {
    className: classnames(props.svgContainerClassName, props.knobContainerClassName)
  }, React.createElement(Knob, {
    className: props.knobClassName
  })));
};